
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.164 12.594v-1.04H9.79v1.04H.164zm5.344-6.578v4.5H4.422v-4.5H.164v-1.04h4.258v-4.5h1.086v4.5H9.78v1.04H5.508z","fill":"currentColor"}})])
          )
        }
      }
    